import React, { Fragment, useEffect, useMemo, useRef, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import fetchAPI from "../../../common/fetchAPI";
import Select, { StylesConfig } from 'react-select';
import 'react-datepicker/dist/react-datepicker.css';
import { dropDownSelectionStyles, getValueFromResource, normalizeDateFormat } from '../../../common/timeLiveFunction';
import { t } from "i18next";
import { updateMyProjectFilters } from '../projectSlice';
import { KTSVG } from '../../../_metronic/helpers';
import DatePickerRanges from '../../../common/DatePickerRanges';
import moment from 'moment';
import { format } from 'date-fns';
import { DateRangePicker } from 'rsuite';
import 'rsuite/dist/rsuite.css';
import fetchTimeliveAPI from '../../../common/fetchTimeliveAPI';

const ProjectFilters = (props: any) => {

    const { modelRef, t, oncloseModal,
        txtProjectCode,
        settxtProjectCode,
        selectedEmployee,
        setSelectedEmployee,
        selectedClient,
        setSelectedClient,
        selectedStatus,
        setSelectedStatus,
        selectedCompleteStatus,
        setSelectedCompleteStatus,
        selectedActive,
        setSelectedActive,
        onApplyFilter } = props;


    const { maxMenuHeight, CurrentCultureDateFormat } = useAppSelector(state => state.globalState);
    const dispatch = useAppDispatch();
    const [selectedOptionEmployee, setSelectedOptionEmployee] = useState<{ [object: string]: any }>();
    const [EmployeeArray, SetEmployeeArray] = useState<any | ''>([]);
    const [selectedOptionStatus, setSelectedOptionStatus] = useState<{ [object: string]: any }>([]);
    const [ProjectStatusArray, setProjectStatusArray] = useState<any | ''>([]);
    const [selectedOptionClient, setSelectedOptionClient] = useState<{ [object: string]: any }>();
    const [ClientsArray, setClientsArray] = useState<any | ''>([]);
    const [selectedOptionCompleteStatus, setSelectedOptionCompleteStatus] = useState({ label: 'All', value: -1 });
    const [selectedProjectCode, setselectedProjectCode] = useState('');
    const [projectTypeOptions, setProjectTypeOptions] = useState<any>([]);
    const [selectedProjectType, setSelectedProjectType] = useState<any>();
    const [displayedRange, setDisplayedRange] = useState('Please Select Date Range');
    const [includeDateRange, setIncludeDateRange] = useState(false);
    const [startDate, setStartDate] = useState<Date>(moment().toDate());
    const [endDate, setEndDate] = useState<Date>(moment().toDate());
    const ActiveInActiveOptions = useMemo(() => [
        { label: 'All', value: -1 },
        { label: getValueFromResource('Active', dispatch, t), value: 0 },
        { label: getValueFromResource('InActive', dispatch, t), value: 1 },
    ], [dispatch, t]);
    const [selectedOptionActive, setSelectedOptionActive] = useState(ActiveInActiveOptions[1])
    const CompletedStatusOptions = [
        { label: 'All', value: -1 },
        { label: getValueFromResource('Completed Projects', dispatch, t), value: 1 },
        { label: getValueFromResource('Incomplete Projects', dispatch, t), value: 0 },
    ];



     const getEmployees = async () => {
            const response = await fetchAPI('api/V2/ExpenseSheets/GetAccountEmployeesForExpenseSheet', "GET", "", true, "d8667f9b-57fd-4ca8-9496-59cbebb5f944");
            const json = await response.json();
            json.map((item: any) => {
                item.value = item.AccountEmployeeId;
                item.label = item.EmployeeName;
                delete item.AccountEmployeeId;
                delete item.EmployeeName;
            });
            json.unshift({ value: '0', label: 'All' })
            SetEmployeeArray(json);
        }

    const getAccountClientsAsync = async () => {
        const response = await fetchAPI("api/V2/Clients/GetClientsbyAccount", "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        const json = await response.json();

        json.Data.map((item: any) => {
            item.value = item.AccountClientId;
            item.label = item.ClientName;
            delete item.AccountClientId;
            delete item.ClientName;
        });

        json.Data.unshift({ value: '0', label: 'All' })
        setClientsArray(json.Data);
    }

    const getProjectStatusByAccount = async () => {
        const response = await fetchAPI("api/v2/Status/GetProjectStatusByAccount", "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        const json = await response.json();

        json.Data.map((item: any) => {
            item.value = item.AccountStatusId;
            item.label = item.Status;
            delete item.AccountStatusId;
            delete item.Status;
        });
        json.Data.unshift({ value: '0', label: 'All' })
        setProjectStatusArray(json.Data);
    }

    const getProjectTypeData = async () => {
        try {
            const response = await fetchTimeliveAPI("api/Project/GetAccountProjectTypes", "GET", "", true);
            const json = await response.json();
            const options = json?.Data?.map((item: any) => ({
                value: item?.AccountProjectTypeId,
                label: item?.ProjectType
            }))
            options.unshift({ value: 0, label: 'All' });
            setProjectTypeOptions(options);
            setSelectedProjectType(0);
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        getProjectTypeData();
    }, [])

    useEffect(() => {

        const savedFilters = JSON.parse(localStorage.getItem('projectFilters') || '{}');
        if (savedFilters) {

            setSelectedOptionStatus(savedFilters.selectedOptionStatus?.value || null);
            setSelectedOptionEmployee(savedFilters.selectedOptionEmployee?.value || null);
            setSelectedOptionClient(savedFilters.selectedOptionClient?.value || null);
            setSelectedOptionCompleteStatus(savedFilters.selectedOptionCompleteStatus?.value || { label: 'All', value: -1 });
            setselectedProjectCode(savedFilters.selectedProjectCode || '');
            setSelectedOptionActive({ label: savedFilters.selectedOptionActive?.label, value: savedFilters.selectedOptionActive?.value });
        }


    }, []);

    const persistFilters = () => {
        const filtersToSave = {
            selectedOptionStatus,
            selectedOptionEmployee,
            selectedOptionClient,
            selectedOptionCompleteStatus,
            selectedProjectCode,
            selectedOptionActive
        };
        localStorage.setItem('projectFilters', JSON.stringify(filtersToSave));
    };


    useEffect(() => {
        getEmployees();
        getAccountClientsAsync();
        getProjectStatusByAccount();
    }, []);


      useEffect(() => {
        if (EmployeeArray.length > 0) {
            if (selectedEmployee) {
                setSelectedOptionEmployee({ label: selectedEmployee?.label, value: selectedOptionEmployee })
            } else {
                setSelectedOptionEmployee(EmployeeArray[0]);
            }
        }
    }, [EmployeeArray]);

    useEffect(() => {
        if (ClientsArray.length > 0) {
            if (selectedClient) {
                setSelectedOptionClient({ label: selectedClient?.label, value: selectedOptionClient })
            } else {
                setSelectedOptionClient(ClientsArray[0]);
            }
        }
    }, [ClientsArray]);

    useEffect(() => {
        if (ProjectStatusArray.length > 0) {
            if (selectedStatus) {
                setSelectedOptionStatus({ label: selectedStatus?.label, value: selectedOptionStatus })
            } else {
                setSelectedOptionStatus(ProjectStatusArray[0]);
            }
        }
    }, [ProjectStatusArray]);

    useEffect(() => {
        if (ActiveInActiveOptions.length > 0) {
            if (selectedActive) {

                // setSelectedOptionActive({label: selectedActive?.label,value: selectedOptionActive?.value});
            } else {
                setSelectedOptionActive(ActiveInActiveOptions[1]);
            }
        }
    }, [ActiveInActiveOptions, selectedActive]);


    const closeButtonRef = useRef<HTMLButtonElement | null>(null);
    useEffect(() => {
        if (ProjectStatusArray.length > 0) {
            setSelectedOptionStatus([ProjectStatusArray[0]]);
        }
    }, [ProjectStatusArray]);

    const handleSubmit = () => {
        const ProjectCode = txtProjectCode;
        const AccountEmployeeId = selectedOptionEmployee?.value || 0;
        const AccountClientId = selectedOptionClient?.value || 0;
        const AccountCompleteStatusId = selectedOptionCompleteStatus?.value === undefined ? -1 : selectedOptionCompleteStatus?.value;
        // const AccountStatusId = selectedOptionStatus?.value || 0;
        let AccountStatusId: any[] = [];
        const isAllSelected = selectedOptionStatus?.some((item: any) => item.value === '0');

        if (isAllSelected) {
            AccountStatusId = ProjectStatusArray.filter((item: any) => item.value !== '0').map((item: any) => item.value);
        } else {
            AccountStatusId = selectedOptionStatus?.map((item: any) => item.value) || [];
        }
        const IsDisabled = selectedOptionActive?.value === undefined ? -1 : selectedOptionActive?.value;

        const filterParams: any = {
            ProjectCode,
            AccountEmployeeId,
            AccountClientId,
            AccountCompleteStatusId,
            AccountStatusId: AccountStatusId.join(','),
            IsDisabled,
            AccountProjectTypeId: selectedProjectType,
            IncludeDateRange: includeDateRange,
            StartDate: includeDateRange ? moment(startDate).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"),
            EndDate: includeDateRange ? moment(endDate).format("YYYY-MM-DD") : moment(startDate).format("YYYY-MM-DD")
        };
        
        dispatch(updateMyProjectFilters(filterParams));
        onApplyFilter(filterParams);
        persistFilters();
        oncloseModal();
    }


    
    const handleChangeEmployees = (selectedOption: any) => {
        setSelectedOptionEmployee(selectedOption);
        setSelectedEmployee(selectedOption);
    };


    const handleChangeClient = (selectedOption: any) => {
        setSelectedOptionClient(selectedOption);
        setSelectedClient(selectedOption);
    };


    const handleChangeProjectStatus = (selectedOption: any) => {

        if (!selectedOption || selectedOption.length === 0) {
            setSelectedOptionStatus([]);
            setSelectedStatus([]);
            return;
        }

        const lastSelected = selectedOption[selectedOption.length - 1];

        if (lastSelected.value === '0') {
            setSelectedOptionStatus([ProjectStatusArray[0]]);
            setSelectedStatus([ProjectStatusArray[0]]);
        } else {
            const filteredOptions = selectedOption.filter((item: any) => item.value !== '0');
            setSelectedOptionStatus(filteredOptions);
            setSelectedStatus(filteredOptions);
        }
    };
    // const handleChangeProjectStatus = (selectedOption: any) => {
    //     setSelectedOptionStatus(selectedOption || []);
    //     setSelectedStatus(selectedOption)
    // };

    const handleChangeActive = (selected: any) => {
        setSelectedOptionActive(selected);
        setSelectedActive(selected);
    };

    const handleChangeCompleteStatus = (selectedOption: any) => {
        setSelectedOptionCompleteStatus(selectedOption);
        setSelectedCompleteStatus(selectedOption)

    };

    const onProjectCodeChange = (e: any) => {
        setselectedProjectCode(e.target.value);
        settxtProjectCode(e.target.value);
    };

    const handleCancel = () => {
        setSelectedEmployee(0);
        setSelectedClient(0);
        setSelectedStatus(0);
        setSelectedCompleteStatus({ label: 'All', value: -1 });
        settxtProjectCode('');

        setSelectedOptionActive(ActiveInActiveOptions[0]);
        const ProjectCode = '';
        const AccountEmployeeId = 0;
        const AccountClientId = 0;
        const AccountCompleteStatusId = -1;
        const AccountStatusId = 0;
        const IsDisabled = 0;


        const filterParams: any = {
            ProjectCode,
            AccountEmployeeId,
            AccountClientId,
            AccountCompleteStatusId,
            AccountStatusId,
            IsDisabled,
            includeDateRange,
            startDate: moment().toDate(),
            endDate: moment().toDate()

        };
        dispatch(updateMyProjectFilters(filterParams));
        oncloseModal();
    };

    const handleDateRangeChange = (value: any) => {
        if (value && value[0] && value[1]) {
            setStartDate(value[0]);
            setEndDate(value[1]);
        }
    };

    const handleIncludeDateRange = (e: any) => {
        setIncludeDateRange(e.target.checked);
    };

    const handleChangeProjectType = (selected: any) => {
        setSelectedProjectType(selected?.value)
    }

    useEffect(() => {
        const style = document.createElement("style");
        style.innerHTML = `
                .rs-picker-default .rs-picker-toggle.rs-btn {
                    z-index: 0 !important;
                }
            `;
        document.head.appendChild(style);
        return () => {
            document.head.removeChild(style);
        };
    }, []);
    
    return (
        <>

            <form>
                <div className='card-body'>

                    {/* <div className="col-md-12">
                        <span className='indicator-progress' style={{ display: 'block' }}>
                            <span className='spinner-border spinner-border-md ms-2'></span>
                        </span>
                    </div> */}

                    <div className="modal drawer-overlay" style={{ display: 'block' }}
                    >
                        <div className="modal-dialog" style={{ maxWidth: '650px' }}>
                            <div className="modal-content" style={{ maxHeight: '88vh', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                                <div className="modal-header" style={{ padding: '.6rem .6rem', flexShrink: 0 }}>
                                    <h5 className="modal-title mainHeading">
                                        {/* {t('Filter')}  */}
                                        {getValueFromResource('Filters', dispatch, t)}
                                    </h5>
                                    <div
                                        className="btn btn-icon btn-sm btn-active-secondary ms-2 "
                                        onClick={oncloseModal}
                                    >
                                        <KTSVG
                                            path="/media/icons/duotune/arrows/arr061.svg"
                                            className="svg-icon svg-icon-1x"
                                        />
                                    </div>
                                </div>
                                <div className="modal-body" style={{ overflowY: 'auto', flex: 1 }}>
                                    <form className='form'>
                                        <div className="col-md-12">
                                            <label className="fs-7 fw-normal mb-2">
                                                {/* {t('Project Code')} */}
                                                {getValueFromResource('Project Code', dispatch, t)}
                                            </label>
                                            <input
                                                type="text"
                                                name="projectCode"
                                                id='projectCode'
                                                className="form-control fs-7 fw-normal"
                                                value={txtProjectCode}
                                                onChange={onProjectCodeChange}
                                            />
                                        </div>


                                         <div className='row spacingBetweenRows'>
                                                            <div className="col-md-12">
                                                                <label className="fs-7 fs-7 fw-normal mb-2">
                                                                    {/* {t('Employee Name')} */}
                                                                    {getValueFromResource('Employee Name', dispatch, t)}
                                                                </label>
                                                                <Select
                                                                    value={selectedOptionEmployee}
                                                                    id="AccountEmployeeId"
                                                                    className="basic-single"
                                                                    classNamePrefix="select"
                                                                    isSearchable={true}
                                                                    name="AccountEmployeeId"
                                                                    onChange={handleChangeEmployees}
                                                                    options={EmployeeArray}
                                                                    styles={dropDownSelectionStyles}
                                                                    maxMenuHeight={maxMenuHeight}
                                                                />
                                                            </div>
                                                        </div>
                                            <div className='row spacingBetweenRows'>
                                            <div className="col-md-12">
                                                <label className="fs-7 fw-normal mb-2">
                                                    {/* {t('Client Name')} */}
                                                    {getValueFromResource('Client Name', dispatch, t)}
                                                </label>
                                                <Select
                                                    value={selectedOptionClient}
                                                    id="AccountClientId"
                                                    className="basic-single"
                                                    classNamePrefix="select"
                                                    isSearchable={true}
                                                    name="AccountClientId"
                                                    onChange={handleChangeClient}
                                                    options={ClientsArray}
                                                    styles={dropDownSelectionStyles}
                                                    maxMenuHeight={maxMenuHeight}
                                                />
                                            </div>
                                        </div>
                                        {/*<div className='row spacingBetweenRows'>
                                            <div className="col-md-12">
                                                <label className="fs-7 fw-normal mb-2">
                                                  
                                                    {getValueFromResource('Completed Status',dispatch, t)}
                                                    </label>
                                                <Select
                                                    value={selectedCompleteStatus}
                                                    className="basic-single"
                                                    classNamePrefix="select"
                                                    isSearchable={true}
                                                    name="CompletedStatus"
                                                    onChange={handleChangeCompleteStatus}
                                                    options={CompletedStatusOptions}
                                                    styles={dropDownSelectionStyles}
                                                    maxMenuHeight={maxMenuHeight}
                                                />

                                            </div>
                                        </div>*/}
                                        <div className='row spacingBetweenRows mb-4'>
                                            <div className="col-md-12">
                                                <label className="fs-7 fw-normal mb-2">
                                                    {/* {t('Project Status')} */}
                                                    {getValueFromResource('Project Status', dispatch, t)}
                                                </label>
                                                <Select
                                                    value={selectedOptionStatus}
                                                    id="AccountStatusId"
                                                    className="basic-single"
                                                    classNamePrefix="select"
                                                    isSearchable={true}
                                                    isMulti
                                                    name="AccountStatusId"
                                                    onChange={handleChangeProjectStatus}
                                                    options={ProjectStatusArray}
                                                    styles={dropDownSelectionStyles}
                                                    maxMenuHeight={maxMenuHeight}
                                                />

                                            </div>
                                        </div>
                                        <div className='row spacingBetweenRows mb-4'>
                                            <div className="col-md-12">
                                                <label className="fs-7 fw-normal mb-2">
                                                    {/* {t('Project Status')} */}
                                                    {getValueFromResource('Project Type', dispatch, t)}
                                                </label>
                                                <Select
                                                    value={projectTypeOptions?.find((item: any) => item?.value === selectedProjectType)}
                                                    id="AccountProjectTypeId"
                                                    className="basic-single"
                                                    classNamePrefix="select"
                                                    isSearchable={true}
                                                    name="AccountProjectTypeId"
                                                    onChange={handleChangeProjectType}
                                                    options={projectTypeOptions}
                                                    styles={dropDownSelectionStyles}
                                                    maxMenuHeight={maxMenuHeight}
                                                />

                                            </div>
                                        </div>
                                        <div className='row spacingBetweenRows mb-4'>
                                            <div className="col-md-12">
                                                <label className="fs-7 fw-normal mb-2">
                                                    {/* {t('Project Status')} */}
                                                    {getValueFromResource('Active /  InActive', dispatch, t)}
                                                </label>
                                                <Select
                                                    id="IsDisabled"
                                                    className="basic-single"
                                                    classNamePrefix="select"
                                                    isSearchable={true}
                                                    name="IsDisabled"
                                                    onChange={handleChangeActive}
                                                    options={ActiveInActiveOptions}
                                                    value={selectedOptionActive}
                                                    styles={dropDownSelectionStyles}
                                                    maxMenuHeight={maxMenuHeight}
                                                />

                                            </div>
                                        </div>
                                        <div className='row spacingBetweenRows mb-4'>
                                            <label className="fs-7 fw-normal mb-2">
                                                {/* {t('Project Status')} */}
                                                {getValueFromResource('Date Range', dispatch, t)}
                                            </label>
                                            <div className="col-md-12">
                                                <DateRangePicker
                                                    onChange={handleDateRangeChange}
                                                    ranges={DatePickerRanges()}
                                                    value={[startDate, endDate]}
                                                    character={' - '}
                                                    placement="top"
                                                    cleanable={false}
                                                    format={normalizeDateFormat(CurrentCultureDateFormat.toString())}
                                                />

                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <label className="form-label fs-7 fw-normal mb-2">
                                                {getValueFromResource('Include Date Range', dispatch, t)}
                                            </label>
                                            <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                                <input
                                                    className="form-check-input h-20px w-30px"
                                                    type="checkbox"
                                                    checked={includeDateRange}
                                                    onChange={(e) => { handleIncludeDateRange(e) }}
                                                />
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div className="modal-footer" style={{ padding: '.6rem .6rem' }} >
                                    <button
                                        type="button"
                                        className="btn btn-secondary btn-bs-btn-font-weight btn-sm" onClick={handleCancel}
                                    // >
                                    // onClick={oncloseModal}
                                    >
                                        {/* {t('Cancel')} */}
                                        {getValueFromResource('Cancel', dispatch, t)}
                                    </button>
                                    <button type="button" className="btn btn-primary  btn-bs-btn-font-weight btn-sm" onClick={() => handleSubmit()} >
                                        {/* {t('Apply Filter')} */}
                                        {getValueFromResource('Apply Filter', dispatch, t)}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>
            </form>

        </>

    )
}
const colourStyles: StylesConfig = {
    control: (styles) => ({ ...styles, backgroundColor: 'white', width: '100%', minHeight: '36px', height: '36px', padding: '-1px' }),
}
export default ProjectFilters